module.exports = require("@material-ui/core/Table");